export const launchConfetti = (canvasEl, buttonEl) => {
  const canvas = canvasEl;
  const button = buttonEl;
  if (!canvas || !button) return;

  const confettiCount = 20;
  const sequinCount = 10;
  const gravityConfetti = 0.3;
  const gravitySequins = 0.55;
  const dragConfetti = 0.075;
  const dragSequins = 0.02;
  const terminalVelocity = 3;

  const ctx = canvas.getContext("2d");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  let cx = ctx.canvas.width / 2;
  let cy = ctx.canvas.height / 2;

  let confetti = [];
  let sequins = [];

  const colors = [
    { front: "#3B82F6", back: "#2563EB" }, // vivid blue (Tailwind blue-500 to 600)
    { front: "#38BDF8", back: "#0EA5E9" }, // light blue-400 to blue-500 (more sky-like, lighter but still blue)
    { front: "#0EA5E9", back: "#0284C7" }, // blue-500 to blue-600 (stronger, pure blue)
  ];

  const randomRange = (min, max) => Math.random() * (max - min) + min;

  const initConfettoVelocity = (xRange, yRange) => {
    const x = randomRange(xRange[0], xRange[1]);
    const range = yRange[1] - yRange[0] + 1;
    let y =
      yRange[1] -
      Math.abs(randomRange(0, range) + randomRange(0, range) - range);
    if (y >= yRange[1] - 1) {
      y += Math.random() < 0.25 ? randomRange(1, 3) : 0;
    }
    return { x: x, y: -y };
  };

  function Confetto() {
    this.randomModifier = randomRange(0, 99);
    this.color = colors[Math.floor(randomRange(0, colors.length))];
    this.dimensions = {
      x: randomRange(5, 9),
      y: randomRange(8, 15),
    };
    const canvasRect = canvas.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();

    this.position = {
      x: randomRange(
        buttonRect.left - canvasRect.left,
        buttonRect.right - canvasRect.left
      ),
      y: randomRange(
        buttonRect.top - canvasRect.top,
        buttonRect.bottom - canvasRect.top
      ),
    };
    this.rotation = randomRange(0, 2 * Math.PI);
    this.scale = { x: 1, y: 1 };
    this.velocity = initConfettoVelocity([-9, 9], [6, 11]);
  }
  Confetto.prototype.update = function () {
    this.velocity.x -= this.velocity.x * dragConfetti;
    this.velocity.y = Math.min(
      this.velocity.y + gravityConfetti,
      terminalVelocity
    );
    this.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();
    this.position.x += this.velocity.x;
    this.position.y += this.velocity.y;
    this.scale.y = Math.cos((this.position.y + this.randomModifier) * 0.09);
  };

  function Sequin() {
    this.color = colors[Math.floor(randomRange(0, colors.length))].back;
    this.radius = randomRange(1, 2);
    const canvasRect = canvas.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();

    this.position = {
      x: randomRange(
        buttonRect.left - canvasRect.left,
        buttonRect.right - canvasRect.left
      ),
      y: randomRange(
        buttonRect.top - canvasRect.top,
        buttonRect.bottom - canvasRect.top
      ),
    };
    this.velocity = {
      x: randomRange(-6, 6),
      y: randomRange(-8, -12),
    };
  }
  Sequin.prototype.update = function () {
    this.velocity.x -= this.velocity.x * dragSequins;
    this.velocity.y += gravitySequins;
    this.position.x += this.velocity.x;
    this.position.y += this.velocity.y;
  };

  const initBurst = () => {
    for (let i = 0; i < confettiCount; i++) confetti.push(new Confetto());
    for (let i = 0; i < sequinCount; i++) sequins.push(new Sequin());
  };

  const render = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    confetti.forEach((c) => {
      let width = c.dimensions.x * c.scale.x;
      let height = c.dimensions.y * c.scale.y;
      ctx.translate(c.position.x, c.position.y);
      ctx.rotate(c.rotation);
      c.update();
      ctx.fillStyle = c.scale.y > 0 ? c.color.front : c.color.back;
      ctx.fillRect(-width / 2, -height / 2, width, height);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    });

    sequins.forEach((s) => {
      ctx.translate(s.position.x, s.position.y);
      s.update();
      ctx.fillStyle = s.color;
      ctx.beginPath();
      ctx.arc(0, 0, s.radius, 0, 2 * Math.PI);
      ctx.fill();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    });

    confetti = confetti.filter((c) => c.position.y < canvas.height);
    sequins = sequins.filter((s) => s.position.y < canvas.height);

    window.requestAnimationFrame(render);
  };

  initBurst();
  render();
};
